import { render, staticRenderFns } from "./MoreOrderreport.vue?vue&type=template&id=5116e580&scoped=true&"
import script from "./MoreOrderreport.vue?vue&type=script&lang=js&"
export * from "./MoreOrderreport.vue?vue&type=script&lang=js&"
import style0 from "./MoreOrderreport.vue?vue&type=style&index=0&id=5116e580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116e580",
  null
  
)

export default component.exports